/****************************************************************************************************
 * MS Websites "Template" resource API Client.
 *
 * @author Dimitris Gkoulis <gkould@gmail.com>
 * @createdAt 18 January 2021
 * @lastModifiedAt Saturday 11 December 2021
 ****************************************************************************************************/

import ApiUrlProvider from '../api-url-provider';
import BaseApiClient from '../base-api-client';

const WebsitesTemplateBasicApiClient = {
    createTemplate (data) {
        const url = ApiUrlProvider.kernelVersionedApi('templates');
        return BaseApiClient.post(url, data);
    },
    updateTemplate (data) {
        const url = ApiUrlProvider.kernelVersionedApi('templates');
        return BaseApiClient.put(url, data);
    },
    getTemplateById (id) {
        const url = ApiUrlProvider.kernelVersionedApi('templates/' + id);
        return BaseApiClient.get(url);
    },
    deleteTemplate (id) {
        const url = ApiUrlProvider.kernelVersionedApi('templates/' + id);
        return BaseApiClient.delete(url);
    },
    getAllTemplatesByTheme (themeId, page = 0, size = 10, sortField = 'id', sortDirection = 'desc') {
        const url = ApiUrlProvider.kernelVersionedApi('templates');
        return BaseApiClient.get(url, {
            params: {
                themeId: themeId,
                page: page,
                size: size,
                sort: sortField + ',' + sortDirection
            }
        });
    }
};

export default WebsitesTemplateBasicApiClient;
